const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {
					ZZ_ALPSGIKEN_AM30101: {
						name: ['(客製)班表匯出', 'Export Shift', '(客制)班表汇出'],
						url: '/zz_alpsgiken_am30101',
						hint: [],
					},				
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};